export const menuPresets = () => {
    return {
        positionFromAnchorEl: {
            bottomRight: {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            },
        },
    };
};
//# sourceMappingURL=menu.js.map